<app-aggregated-amount-item
  [name]="(selectedArtist$ | async)?.nameMain"
  icon="./assets/tiktok.png"
  amount="{{ (tiktokFollower$ | async)?.units }}"
  unit="フォロワー数"
  [rate]="(tiktokFollower$ | async)?.rate"
  [link]="((selectedArtist$ | async)?.shareablee)[0].tiktokUrl"
  [hasAmount]="(tiktokFollower$ | async)?.hasUnits"
  [loading]="loading$ | async"
  help="Chartmetricに登録された {{
    !((selectedArtist$ | async)?.shareablee)[0].tiktokUrl
      ? 'TikTok'
      : ((selectedArtist$ | async)?.shareablee)[0].tiktokUrl
  }} のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
  [isDecimal]="true"
></app-aggregated-amount-item>
